import {Routes} from '@angular/router';
import {environment} from '../environments/environment';

export const routes: Routes = [
  {
    path: '',
    title: `${environment.program} PRECHECK`,
    children: [
      { path: '', loadComponent: () => import('./home/home.component').then((c) => c.HomeComponent) },
      { path: 'error', loadComponent: () => import('./error/error.component').then((c) => c.ErrorComponent) },
      { path: ':key', loadComponent: () => import('./inspect/inspect.component').then((c) => c.InspectComponent) },
      {  path: ':key/:itemId', loadComponent: () => import('./inspect/item/item.component').then((c) => c.ItemComponent) },
      { path: '**', redirectTo: 'error' },
    ],
  },
];
